// extracted by mini-css-extract-plugin
module.exports = {"mobile":"App_mobile__6HKLj"};